// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.qH3QzOO3RZ21Gcaqnrrf{position:relative;display:inline-block;margin-left:auto}.WX3zbaFURjsm5kPqOIUe{position:relative;display:flex;align-items:center;gap:8px}.YI2u7GCa9aDJPpqpbSF0{border-radius:4px;padding:2px;-webkit-tap-highlight-color:rgba(0,0,0,0)}.YI2u7GCa9aDJPpqpbSF0.UvFMJBNbP3FjyeTsXo6U{background-color:#c9c9c9}.YI2u7GCa9aDJPpqpbSF0.YtGrGotjMDokp494doV6:hover{background-color:#c9c9c9}.UQDCNRZVBCEX5p3unwSo{display:flex;cursor:pointer;-webkit-tap-highlight-color:rgba(0,0,0,0)}.jYZIc27Z64tEfkvgbDVr{margin-left:14px}.jYZIc27Z64tEfkvgbDVr svg{margin-right:14px}.jYZIc27Z64tEfkvgbDVr svg path{fill:currentColor}.AwG1gw7OeLbskN6WlwYf{position:static;width:24px;height:24px;font-size:14px;line-height:24px;font-family:"UbuntuMedium",Arial,Helvetica,sans-serif}.bJUBT26CbTckCMlw2e_T{padding:2px;margin-left:4px}.vEZjcZspMmHX8a8sNLqX.EGdEO2zPQjY8LXhR7ctY{right:0;width:190px;font-size:14px}.vEZjcZspMmHX8a8sNLqX .QBBnjhZ8rx7sgSWkpzl4{display:none}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `qH3QzOO3RZ21Gcaqnrrf`,
	"iconsContainer": `WX3zbaFURjsm5kPqOIUe`,
	"menuButton": `YI2u7GCa9aDJPpqpbSF0`,
	"open": `UvFMJBNbP3FjyeTsXo6U`,
	"desktop": `YtGrGotjMDokp494doV6`,
	"menuToggleWrapper": `UQDCNRZVBCEX5p3unwSo`,
	"reportMenuItem": `jYZIc27Z64tEfkvgbDVr`,
	"headerBadge": `AwG1gw7OeLbskN6WlwYf`,
	"reportIcon": `bJUBT26CbTckCMlw2e_T`,
	"desktopUnified": `vEZjcZspMmHX8a8sNLqX`,
	"msgHeaderMenu": `EGdEO2zPQjY8LXhR7ctY`,
	"divider": `QBBnjhZ8rx7sgSWkpzl4`
};
export default ___CSS_LOADER_EXPORT___;
